/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p.error[_ngcontent-%COMP%]{color:red}h5.left.floated[_ngcontent-%COMP%]{margin-top:8px;margin-right:15px}.times.icon[_ngcontent-%COMP%]{position:absolute;top:10px;right:10px}.ui.inverted.segment[_ngcontent-%COMP%]{background:#344a77;border-radius:0;padding:1em 1.5em}h3[_ngcontent-%COMP%]{margin-top:14px}.password-input[_ngcontent-%COMP%]{margin-bottom:5px}"];
export { styles as styles };
